import { axiosInstance } from './axios-instance';
import { PAGE_SIZE } from '../magic-values';
import type { PaginationDto } from '../types/common';
import type { Job, ListJobsResponse } from '../types/job';

export interface JobsFilters {
  accountId: string;
  filterBy?: string;
  status?: string;
  type?: string;
  trigger?: string;
}

export class JobService {
  static async getJobs(
    filters: JobsFilters,
    pagination?: PaginationDto,
  ): Promise<ListJobsResponse> {
    const res = await axiosInstance.get<ListJobsResponse>('/admin/jobs', {
      params: { pageSize: PAGE_SIZE, ...pagination, ...filters },
    });
    return res.data;
  }

  static async getJob(id: string, accountId: string): Promise<Job> {
    const res = await axiosInstance.get<Job>(`/admin/jobs/${id}`, { params: { accountId } });
    return res.data;
  }
}
